export const useTheme = () => {
    return {};
};
